import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateCompanyKYCStatusRequest,
  TUpdateCompanyKYCStatusResponse,
} from "./updateCompanyKYCStatus.schema";

export const updateCompanyKYCStatus = (axios: IAxiosInstance) => {
  return async (data: TUpdateCompanyKYCStatusRequest) => {
    const { companyID, kyc_status } = data;

    const response = await axios.noRetry.patch<
      IApiResponse<TUpdateCompanyKYCStatusResponse>
    >(`/api/companies/${companyID}/kyc-status`, {
      kyc_status,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
